import { useState } from "react";
import { toast } from "sonner";
import { pu } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { TEMI, salvaTema, temaDispositivo } from "@/lib/tema";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Palette, Check } from "lucide-react";

/** Colori del gestionale: ognuno scegle sul proprio telefono, il titolare decide la partenza. */
export const TemaCard = () => {
  const { user, settings, refresh } = useApp();
  const [scelto, setScelto] = useState(temaDispositivo() || settings?.theme || "chiaro");
  const titolare = user?.role === "titolare";

  const scegli = (id) => {
    setScelto(id);
    salvaTema(id);
  };

  return (
    <Card className="space-y-4 p-6" data-testid="tema-card">
      <div className="flex items-start gap-3">
        <Palette className="mt-0.5 h-5 w-5 shrink-0 text-slate-700" />
        <div>
          <h3 className="font-semibold">Colori</h3>
          <p className="mt-1 text-sm text-slate-500">
            La scelta vale su <b>questo dispositivo</b>: chi lavora in sala di sera può stare sul tema
            scuro mentre tu in ufficio resti sul chiaro.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">
        {TEMI.map((t) => (
          <button
            key={t.id}
            onClick={() => scegli(t.id)}
            data-testid={`tema-${t.id}`}
            className={`rounded-xl border p-4 text-left transition-colors ${scelto === t.id ? "border-slate-900 bg-slate-50" : "border-slate-200 hover:border-slate-400"}`}
          >
            <span className="flex items-center justify-between">
              <span className="text-sm font-semibold">{t.nome}</span>
              {scelto === t.id && <Check className="h-4 w-4" />}
            </span>
            <span className="mt-1 block text-xs text-slate-500">{t.nota}</span>
          </button>
        ))}
      </div>

      {titolare && (
        <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-slate-50 p-3">
          <p className="min-w-0 text-xs text-slate-600">
            Partenza per i dispositivi nuovi del locale: <b>{TEMI.find((x) => x.id === (settings?.theme || "chiaro"))?.nome}</b>
          </p>
          <Button size="sm" variant="outline" data-testid="tema-default-btn"
                  onClick={async () => {
                    await pu("/settings", { ...settings, cover_charge: Number(settings.cover_charge) || 0, theme: scelto });
                    await refresh();
                    toast.success("Da ora i telefoni nuovi partono con questo tema");
                  }}>
            Usa questo come partenza
          </Button>
        </div>
      )}
    </Card>
  );
};
